import { connect } from 'react-redux';
import { IAppState, Dispatch } from '../../../../../../../common/state';
import { ERentTime } from '../../../../../../../json_query';
import { changeRentTime } from '../../../../../../state/advanced/rent_time';
import { RentTimeComponent } from './rentTime';

export interface IRentTimeProps {
  rentTime: ERentTime;
  onRentTimeChanged(value: string | undefined): void;
}

export function mapStateToProps(state: IAppState) {
  return {
    rentTime: (state.filters.jsonQuery.for_day && state.filters.jsonQuery.for_day.value) || ERentTime.NotDaily,
  };
}

export function mapDispatchToProps(dispatch: Dispatch) {
  return {
    onRentTimeChanged: (value: ERentTime) => {
      dispatch(changeRentTime(value));
    },
  };
}

export const RentTime = connect(mapStateToProps, mapDispatchToProps)(RentTimeComponent);
